import { GITA_LANGUAGES } from '../config/languages';

const LANG_NAMES = Object.fromEntries(
  GITA_LANGUAGES.map((l) => [l.code, l.label.split('—')[0].trim()])
);

/**
 * Updates document title for reader routes (helps tabs & basic SEO signal).
 */
export function setReaderDocumentTitle(chapterNumber, slokaNumber, languageCode = 'en') {
  const lang = LANG_NAMES[languageCode] || languageCode;
  document.title = `Bhagavad Gita — Ch. ${chapterNumber}, Verse ${slokaNumber} (${lang}) | The Gita`;
}

export function setAboutDocumentTitle() {
  document.title = 'About — The Gita';
}

export function setDefaultDocumentTitle() {
  document.title = 'The Gita — Bhagavad Gita reader';
}
